import { Button } from "@/components/shadcn/button";
import { setEditImageModal } from "@/store/features/bulkResize/actions";
import { BulkResizeState } from "@/store/features/bulkResize/types";
import { useAppDispatch, useAppSelector } from "@/store/store";
import { ArrowLeft, ArrowRight } from "lucide-react";

interface NavigationProps {
    imageId: string;
    operation: NonNullable<BulkResizeState["editImageModal"]>["operation"];
}

export const Navigation = ({ imageId, operation }: NavigationProps) => {
    const dispatch = useAppDispatch();
    const data = useAppSelector((store) => {
        const images = store.bulkResize.images;
        const index = images.findIndex((image) => image.id === imageId);
        if (index < 0) return null;
        const nextImageId = images.at(index + 1)?.id;
        const prevImageId = index < 1 ? null : images.at(index - 1)?.id;
        return { nextImageId, prevImageId };
    });

    const handlePrevious = () => {
        if (!data?.prevImageId) return;
        dispatch(setEditImageModal({ imageId: data.prevImageId, operation }));
    };

    const handleNext = async () => {
        if (!data?.nextImageId) return;
        dispatch(setEditImageModal({ imageId: data.nextImageId, operation }));
    };

    if (!data || (!data.nextImageId && !data.prevImageId)) return null;
    return (
        <div className="px-4 flex gap-2 md:gap-4 justify-between items-center">
            {data.prevImageId ? (
                <Button
                    className="flex w-[100px] md:w-[110px] items-center justify-center gap-2 text-xs md:text-base font-semibold bg-irBlue-400 hover:bg-irBlue-200 dark:bg-darkSurface-200 dark:hover:bg-darkSurface-300 text-white"
                    onClick={handlePrevious}
                >
                    <div className="hidden sm:block">
                        <ArrowLeft className="w-4 h-4" />
                    </div>
                    Previous
                </Button>
            ) : null}
            {data.nextImageId ? (
                <Button
                    className="flex w-[100px] md:w-[110px] items-center justify-center gap-2 text-xs md:text-base font-semibold bg-irBlue-400 hover:bg-irBlue-200 dark:bg-darkSurface-200 dark:hover:bg-darkSurface-300 text-white"
                    onClick={handleNext}
                >
                    Next
                    <div className="hidden sm:block">
                        <ArrowRight className="w-4 h-4" />
                    </div>
                </Button>
            ) : null}
        </div>
    );
};
